import type { Order } from "../../../../../../../services";

const cellProcessing = (item?: Order.Model["passengers"]): number =>
	item?.[0]?.rideNumber ?? 1;

export default cellProcessing;
